import ReactGA from 'react-ga';
import { IAnalyticsWriter } from './IAnalyticsWriter';
import { AnalyticsEventModel } from 'shisell';
import { logger } from '@soluto-home-web/platform-utils';
import { getFromTweek } from '@soluto-home-web/platform-core';

class GoogleAnalyticsWriter implements IAnalyticsWriter {
  private _isEnabled: boolean | null = null;

  async isWriterEnabled(): Promise<boolean> {
    const isEnabledPromise = getFromTweek('soluto_home_web/analytics/google/is_enabled');
    const trakingCodePromise = getFromTweek('soluto_home_web/analytics/google/tracking_code');

    const isEnabled = await isEnabledPromise;
    const trakingCode = await trakingCodePromise;

    let isWriterEnabled = !!isEnabled === true;
    if (!isWriterEnabled) return false;

    if (!trakingCode) {
      logger.error('Could not get tracking code for partner', new Error());
      return false;
    }
    ReactGA.initialize(trakingCode);
    return true;
  }

  async isEnabled(): Promise<boolean> {
    if (this._isEnabled == null) {
      this._isEnabled = await this.isWriterEnabled();
    }

    return this._isEnabled || false;
  }

  isPageViewAnalytics(eventModel: AnalyticsEventModel): boolean {
    const extraDataKeys = eventModel.ExtraData && Object.keys(eventModel.ExtraData);
    return eventModel.Name == 'PageView' && extraDataKeys && extraDataKeys.indexOf('Page') > -1;
  }

  getActionForEvent(eventModel: AnalyticsEventModel): string | false {
    if (!eventModel.ExtraData) {
      return false;
    }

    return (
      eventModel.ExtraData.Section || eventModel.ExtraData.Page || eventModel.ExtraData.ActionId || false
    );
  }

  async write(eventModel: AnalyticsEventModel): Promise<void> {
    ReactGA.set(eventModel.ExtraData);

    if (this.isPageViewAnalytics(eventModel)) {
      ReactGA.pageview(window.location.pathname + window.location.search, undefined, eventModel.ExtraData.Page);
      return;
    }

    const actionId = this.getActionForEvent(eventModel);
    if(actionId) {
      const gaEventModel: ReactGA.EventArgs = {
        category: eventModel.Name,
        action: actionId,
      };

      ReactGA.event(gaEventModel); 
    }
  }
}

export default new GoogleAnalyticsWriter();



// WEBPACK FOOTER //
// ./packages/web-app/src/services/analyticsWriters/GoogleAnalyticsWriter.ts